import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import LoginPage from "~/pages/LoginPage";

const loginSearchParams = z.object({
  redirectTo: z
    .string()
    .refine((v) => v.startsWith("/") && !v.startsWith("//"), {
      message: "redirectTo must be a relative path",
    })
    .optional(),
});

export const Route = createFileRoute("/_public/login")({
  validateSearch: loginSearchParams,
  component: () => {
    const { redirectTo } = Route.useSearch();
    return <LoginPage redirectTo={redirectTo} />;
  },
});
